import { APP_DATE_FORMAT, APP_DATE_FORMAT_MID } from "@/config/constants";
import { Button } from "@/components/ui";
import { IEdoCourseEvent } from "@/shared/model/edo-course-event.model";
import axios from "axios";
import "moment/locale/it";
import { useEffect, useState } from "react";
import { TextFormat } from "react-jhipster";
import { Link } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui";
import { Loader2 } from "lucide-react";
import { cn } from "@/shared/util/cn";

export interface ViewEventoInsegnamentoProps {
  eventId: number;
  open: boolean;
  handleClose: () => void;
}

export const ViewEventoInsegnamento = (props: ViewEventoInsegnamentoProps) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [event, setEvent] = useState<IEdoCourseEvent | null>(null);
  const { eventId, open, handleClose } = props;

  useEffect(() => {
    const getEvent = async (id: number) => {
      setLoading(true);
      const response = await axios.get(`/course-events/${id}`);
      setEvent(response.data);
      setLoading(false);
    };
    if (eventId && open) {
      getEvent(eventId);
    }
  }, [eventId, open]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent
        className={cn("max-w-lg sm:max-w-lg", "max-h-[90vh] overflow-y-auto")}
      >
        {loading ? (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
          </div>
        ) : event ? (
          <>
            <DialogHeader>
              <DialogTitle>
                Evento del{" "}
                <TextFormat
                  type="date"
                  value={event.startDate}
                  format={APP_DATE_FORMAT_MID}
                  locale="it"
                />
              </DialogTitle>
            </DialogHeader>
            <div className="space-y-4">
              <div>
                <h2 className="text-heading-sm font-semibold text-[var(--color-mockup-text)]">
                  {event.title}
                </h2>
                <p className="mt-1 text-body text-[var(--color-mockup-text-mid)]">
                  {event.description}
                </p>
              </div>
              <div className="border-t border-[var(--color-mockup-border)]" />
              <p className="text-body text-[var(--color-mockup-text-mid)]">
                Insegnamento:{" "}
                <Link
                  to={`/courses/${event.course.id}`}
                  className="font-medium text-primary hover:underline"
                >
                  {event.course.subject.name} (
                  {event.course.class.year.year}
                  {event.course.class.section})
                </Link>
              </p>
              <div className="flex flex-wrap justify-between gap-4 text-body text-[var(--color-mockup-text-mid)]">
                <span>
                  Data inizio:{" "}
                  <TextFormat
                    type="date"
                    value={event.startDate}
                    format={APP_DATE_FORMAT}
                    locale="it"
                  />
                </span>
                <span>
                  Data fine:{" "}
                  <TextFormat
                    type="date"
                    value={event.endDate}
                    format={APP_DATE_FORMAT}
                    locale="it"
                  />
                </span>
              </div>
            </div>
            <DialogFooter className="mt-4">
              <Button onClick={handleClose}>Chiudi</Button>
            </DialogFooter>
          </>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};
